import {TableBody} from "@mui/material";
import {FC, ReactNode} from "react";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    children: ReactNode,
    sx?: SxType
}

const TbodyCustom: FC<IProps> = ({children, sx}) => {
    return (
        <TableBody sx={sx}>
            {children}
        </TableBody>
    );
};

export default TbodyCustom;